export default {
    Metadata: {
        Name: "SubString",
        Description: "Returns the substring of a given string using a start position and length.",
        Syntax: "SubString(string, startPos_number, length_number)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(fullString, startPos, length) { //Overload
        if (fullString != null) {
            if (typeof fullString != 'string') {
                fullString = fullString.toString();
            }

            if (length == undefined)
                length = fullString.length - startPos;  //Read to the end if missing..EK

            return fullString.substr(startPos, length);
        }
        else
            return null;
    },
};

